const laser_tr ={
    title: "Lazer Kesim ve Metal İmalat",
    text:"Ankor Makina, lazer kesim metal imalat hizmetleri ile projeye özel çözümler sunar. Sadece kesim değil; üretilebilir tasarım, doğru malzeme seçimi ve teknik detaylandırma süreçlerinde de mühendislik desteği sağlar. Mimari ve endüstriyel uygulamalarda, çizimden üretime kadar uçtan uca hizmet verilir.",
    sub_title:"İlginizi çekti mi? Lazer kesim çözümlerimiz hakkında daha fazla bilgi almak için hemen inceleyin.",
    button_text:"Hemen iletişime geçin"

}

const laser_en ={
    title: "Laser Cutting and Metal Fabrication",
    text: "Ankor Makina provides project-specific solutions with its laser cutting and metal fabrication services. Not only cutting; it also offers engineering support in manufacturable design, correct material selection, and technical detailing processes. In architectural and industrial applications, end-to-end services are provided from drawing to production.",
    sub_title:"Interested? Discover more about our laser cutting solutions and explore the details.",
    button_text:"Contact Us Now"
}


module.exports = { laser_tr, laser_en }